import { Component, EventEmitter, OnInit, ViewChild,HostListener,ElementRef, signal } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { Operator } from '../../bo/operator';
import { OperatorRoles } from '../../bo/operatorRoles';
import { FonctionsService } from '../../services/fonctions-partagees.service';

@Component({
  selector: 'app-operateurs-modale',
  templateUrl: './operateurs-modale.component.html',
  styleUrls: ['./operateurs-modale.component.scss'],
  standalone: false
})
export class OperateursModaleComponent implements OnInit {
  
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  @ViewChild('modalConfirmSuppr') modalConfirmSuppr: ModalDirective;
  @ViewChild('dropdownElement') dropdownElement: ElementRef;
  modaleFermee = new EventEmitter<boolean>();

  operator = signal<Operator>(null);
  operatorModif = signal<Operator>(null);
  estModif = signal<boolean>(false);
  siteId = signal<number>(null);

  success = signal<boolean>(false);
  erreurApi = signal<boolean>(false);
  roles = signal([
    { id: 1, name: 'BLASTER', selected: false },
    { id: 2, name: 'OPERATOR', selected: false },
  ]);
  selectedRoles = signal<string[]>([]);
  dropdownOpen = signal<boolean>(false);


  constructor(public bsModalRef: BsModalRef, private readonly http: HttpService, public fonctionsService: FonctionsService,  private readonly elementRef: ElementRef
  ) { }

  ngOnInit() {
    if (null != this.operator()) {
      this.operatorModif.set(JSON.parse(JSON.stringify(this.operator())));
    }
    else {
      this.operatorModif.set(new Operator());
    }
    this.selectedRoles.set(this.operatorModif().roles ? 
      this.operatorModif().roles
        .filter(role => OperatorRoles[role] !== undefined && OperatorRoles[role] !== null)
        .map(role => OperatorRoles[role].toString()) 
      : []);

    this.roles().forEach((role) => {
      role.selected = this.selectedRoles().includes(role.name);
    });

  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel.show();
    }
    else
      this.bsModalRef.hide();
  }

  hideModalCancel() {
    this.modalConfirmCancel.hide();
  }

  showConfirmSuppr() {
    this.modalConfirmSuppr.show();
  }

  hideConfirmSuppr() {
    this.modalConfirmSuppr.hide();
  }

  onSubmit() {
    const modif = this.operatorModif();
    modif.siteId = this.siteId();
    this.operatorModif.set(modif);
    if (undefined !== this.operatorModif().identifiant && this.operatorModif().identifiant.length > 0) {
      this.fonctionsService.loading_screen(true);
      this.http.post<Operator, Operator>('Sites/' + this.siteId() + '/Operator', this.operatorModif())
        .subscribe(resultat => {
          if (resultat)
            this.success.set(true);
          else
            this.erreurApi.set(true);
          this.fonctionsService.loading_screen(false);

          if (!this.erreurApi()) {
            this.bsModalRef.hide();
            this.modaleFermee.emit(true);
          }
        }, () => {
          this.erreurApi.set(true);
          this.fonctionsService.loading_screen(false);
        });
    }
  }
  

  delete() {
    if (this.estModif() && undefined !== this.operator() && null !== this.operator()) {
      this.http.delete<boolean>('Sites/' + this.siteId() + '/Operator/ ' + this.operator().operatorId).subscribe(resultat => {
        if (resultat)
          this.success.set(true);
        else
          this.erreurApi.set(true);
        this.fonctionsService.loading_screen(false);

        if (!this.erreurApi()) {
          this.bsModalRef.hide();
          this.modaleFermee.emit(true);
        }
      }, () => {
        this.erreurApi.set(true);
        this.fonctionsService.loading_screen(false);
      });
    }
  }
  onRoleChange(): void {
    this.updateSelectedRoles();
  }
  
  updateSelectedRoles(): void {
    this.selectedRoles.set(this.roles()
      .filter((role) => role.selected)
      .map((role) => role.name));

    const modif = this.operatorModif();
    modif.roles = this.roles()
    .filter((role) => role.selected)
    .map((role) => role.id as OperatorRoles);
    this.operatorModif.set(modif);
  
  }
  
  
  toggleDropdown() {
    this.dropdownOpen.set(!this.dropdownOpen());
  }
  closeDropdown(): void {
    this.dropdownOpen.set(false);
  }

    private diff(): boolean {
      return false;
    }
    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event): void {
      const target = event.target as HTMLElement;
      if (target && this.dropdownElement && !this.dropdownElement.nativeElement.contains(target)) {
        this.dropdownOpen.set(false);
      }
    }
}
